import React from 'react';
import {
  AppBar,
  AppBarDataCustomItem,
  Button,
  ScrollableViewport,
} from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding/InnerPagePadding';
import { TransparentButton } from 'shared/components/Buttons';
import saveIcon from 'shared/assets/icons/save.svg';
import { useAppSelector } from 'state/store';
import { currentReportSelector } from 'state/store/selectors';
import { HeaderBar } from 'shared/components/HeaderBar';
import { SearchTreeReports } from '../components/SearchTreeReports';
import { ConfirmExitModal } from '../components/ConfirmExitModal';
import { NewReportForm } from '../components/NewReportForm';
import { useReportForm } from '../hooks';
import { HeaderButtonWrapper } from '../components/HeaderButtonWrapper';

export const EditReport: React.FC = () => {
  const initialForm = currentReportSelector(useAppSelector((state) => state));
  const {
    onUpdate,
    form,
    setForm,
    isLoading,
    isModalVisible,
    setModalVisible,
    onConfirmModal,
  } = useReportForm({
    initialForm,
  });

  const cancelButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton
          text="Cancel"
          onClick={() => setModalVisible(true)}
          iconSrc="Close"
        />
      </HeaderButtonWrapper>
    ),
  };

  const saveButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button
          text="Save"
          onClick={onUpdate}
          iconSrc={saveIcon}
          disabled={isLoading}
        />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <>
      <>
        <PageContent
          searchTree={
            <SearchTreeReports
              setModalVisible={setModalVisible}
              showConfirmExitModal
              disableAddButton
            />
          }
          headerControls={
            <AppBar menuItems={[cancelButton, saveButton]}>
              <HeaderBar title="Edit Report" />
            </AppBar>
          }
        >
          <ScrollableViewport vertical>
            <InnerPagePadding>
              <NewReportForm form={form} setForm={setForm} />
            </InnerPagePadding>
          </ScrollableViewport>
        </PageContent>

        <ConfirmExitModal
          isVisible={isModalVisible}
          setVisibility={setModalVisible}
          onConfirm={onConfirmModal}
        />
      </>
    </>
  );
};
